module.exports = __webpack_public_path__ + "img/sub.1df9ecdb.jpg";